export default {
  name: 'checklist-fix',
  components: {},
  props: [],
  data () {
    return {
      chk_item_fix: [],
      loading: false,
      filter: this.$t('checklist_fix.all'),
      stt: 4
    }
  },
  computed: {

  },
  mounted () {
    this.$loading.start()
    this.loading = true
    Promise.all([
      this.$store.dispatch('Dashboard/getChecklistFix', { stt: this.stt })
    ]).then(res => {
      console.log(res)
      this.chk_item_fix = res[0]
      this.loading = false
      this.$loading.complete()
    }).catch(errors => {
      this.loading = false
      this.$loading.fail()
    })
  },
  methods: {
    _fix (checklist, checklist_item = {}) {
      this.$router.push('/checklist/' + checklist.id + '/view?group=' + checklist_item.grp_chk_item_id + '&checklist_item=' + checklist_item.id)
    },
    _filter (key) {
      switch (key) {
        case 1:
          this.stt = 1
          this.filter = 'Hôm nay'
          this.$loading.start()
          this.loading = true
          Promise.all([
            this.$store.dispatch('Dashboard/getChecklistFix', { stt: this.stt })
          ]).then(res => {
            this.chk_item_fix = res[0]
            this.loading = false
            this.$loading.complete()
          }).catch(errors => {
            this.loading = false
            this.$loading.fail()
          })
          break
        case 2:
          this.stt = 2
          this.filter = 'Trong tháng'
          this.$loading.start()
          this.loading = true
          Promise.all([
            this.$store.dispatch('Dashboard/getChecklistFix', { stt: this.stt })
          ]).then(res => {
            this.chk_item_fix = res[0]
            this.loading = false
            this.$loading.complete()
          }).catch(errors => {
            this.loading = false
            this.$loading.fail()
          })
          break
        case 3:
          this.stt = 3
          this.filter = 'Trong năm'
          this.$loading.start()
          this.loading = true
          Promise.all([
            this.$store.dispatch('Dashboard/getChecklistFix', { stt: this.stt })
          ]).then(res => {
            this.chk_item_fix = res[0]
            this.loading = false
            this.$loading.complete()
          }).catch(errors => {
            this.loading = false
            this.$loading.fail()
          })
          break
        case 4:
          this.stt = 4
          this.filter = 'Tất cả'
          this.$loading.start()
          this.loading = true
          Promise.all([
            this.$store.dispatch('Dashboard/getChecklistFix', { stt: this.stt })
          ]).then(res => {
            this.chk_item_fix = res[0]
            this.loading = false
            this.$loading.complete()
          }).catch(errors => {
            this.loading = false
            this.$loading.fail()
          })
          break
        default:
          this.stt = 4
          this.filter = 'Tất cả'
          this.$loading.start()
          this.loading = true
          Promise.all([
            this.$store.dispatch('Dashboard/getChecklistFix', { stt: this.stt })
          ]).then(res => {
            this.chk_item_fix = res[0]
            this.loading = false
            this.$loading.complete()
          }).catch(errors => {
            this.loading = false
            this.$loading.fail()
          })
          break
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist-fix/checklist-fix.js